import React, { useEffect } from 'react';
import { DialogComponent } from '../../../../../Components';
import { LookupSelect } from '../../../ActivitiesTypeView/ActivitiesTypeManagementView/DialogManagementViewComponent/DialogManagementConrtolComponent/LookupSelect';

const SourceOfLeadBulkUpdate = ({ open, onClose, onSave }) => {
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  useEffect(() => {
    return () => {
      setSelectedStatus(null);
    };
  }, [open]);
  return (
    <DialogComponent
      isOpen={open}
      onCloseClicked={onClose}
      onCancelClicked={onClose}
      onSaveClicked={(e) => {
        e.preventDefault();
        onSave(selectedStatus);
      }}
      saveIsDisabled={!selectedStatus}
      titleText={'update source of lead'}
      dialogContent={
        <div className='d-flex fj-center fa-center'>
          <LookupSelect
            lookupName={'sourceOfLead'}
            className={'w-270px'}
            value={selectedStatus}
            onSelectChanged={setSelectedStatus}
          />
        </div>
      }
      maxWidth={'sm'}
    />
  );
};
export default SourceOfLeadBulkUpdate;
